import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { App } from 'antd';
import { useNavigate } from 'react-router-dom';

import { RecommendationsModal } from '../components/RecommendationsModal';
import { useCreateRecommendationsMutation } from '../service/recommendations-ai.api';
import validationSchema from '../utils/form';
import { RecommendationsProps } from '../service/recommendations.interface';

export const RecommendationsCreateContainer = () => {
    const { notification } = App.useApp();
    const navigate = useNavigate();

    const [createRecommendations, { isSuccess, isLoading }] =
        useCreateRecommendationsMutation();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Рекомендации настроены',
                description: 'Изучить подробнее можно в истории.',
            });
            navigate(-1);
        }
    }, [isSuccess]);

    const onSubmit = () => {
        createRecommendations({ ...formik.values });
    };

    const formik = useFormik<RecommendationsProps>({
        initialValues: {
            period: null,
            community_ids: [],
        },
        onSubmit: onSubmit,
        validationSchema: validationSchema,
    });

    return (
        <RecommendationsModal
            isLoading={isLoading}
            onSubmit={onSubmit}
            formik={formik}
        />
    );
};
